import { render, staticRenderFns } from "./FreightTablesTable.vue?vue&type=template&id=5954fd1a&scoped=true"
import script from "./FreightTablesTable.vue?vue&type=script&lang=js"
export * from "./FreightTablesTable.vue?vue&type=script&lang=js"
import style0 from "./FreightTablesTable.vue?vue&type=style&index=0&id=5954fd1a&prod&scoped=true&lang=less"
import style1 from "./FreightTablesTable.vue?vue&type=style&index=1&id=5954fd1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5954fd1a",
  null
  
)

export default component.exports